// 茶屋のたまき（AI）と話す専用画面（#/support）。中身は ui/support.ts（会話劇の形）
import { SUPPORT } from '@hyakki/core';
import { go, register } from '../router';
import { state } from '../state';
import { guestBlocked } from '../ui/google-link';
import { mountSupport } from '../ui/support';

register('support', {
  title: '茶屋',
  full: true,
  mount: (el) => {
    // たまき（AI）はチャットチケットが要るので Google 連携したアカウントだけ
    if (state.me?.user.guest) {
      go('top', {}, true);
      queueMicrotask(() => guestBlocked(`${SUPPORT.name}と話すには、Google連携が必要です（AIの返事にチャットチケットを使うため）。`));
      return;
    }
    return mountSupport(el);
  },
});
